import React from 'react';
import Toggle from '../Toggle/Toggle';
import './Navbar.css';
import {Link} from 'react-scroll';
import Bar from '@iconscout/react-unicons/icons/uil-bars'

function Navbar() {
  return (
    <div>
      <div className="n-wrapper">
        <div className="n-left">
          <div className="n-name">Kyaw<span className='hide'> Lwin Soe</span></div>
          <Toggle />
        </div>
        <div className="n-right">
          <div className="n-list">
            <ul style={{listStyleType: 'none'}}>
              <Link spy={true} to='Navbar' smooth={true} activeClass='activeClass'>
                <li>Home</li>
              </Link>
              <Link spy={true} to='About' smooth={true}>
                <li>About</li>
              </Link>
              <Link spy={true} to='Services' smooth={true}>
                <li>Services</li>
              </Link>
              <Link spy={true} to='Experience' smooth={true}>
                <li>Experience</li>
              </Link>
              <Link spy={true} to='Portfolio' smooth={true}>
                <li>Portfolio</li>
              </Link>
              
            </ul>
          </div>
          <button className='button nav-button'>
            <Bar size='1rem'/>
          </button>
          <Link spy={true} to ='Contact' smooth={true}>
          <button className="button n-button">
            Contact
          </button>
          </Link>
          
        </div>
      </div>
    </div>
  )
}

export default Navbar
